import { getEndpointBff } from 'services/projeto';
import { getApis } from '../../library/Apis';
import { toRequest } from '../../utils/RequestUtils';
import { PROJECT_STATUS_RASCUNHO } from './../../library/ProjectStatus';
import { FIXED_PRINCIPOS_VALORES } from './ProjetoReducer';
import { convertDateToIso } from 'utils/DateUtils';
import api from 'services/api';

export const RESETED_PROJETOS = 'RESETED_PROJETOS';
export const CHANGED_PROJECT_CHANGED_AVALIACAO =
  'CHANGED_PROJECT_CHANGED_AVALIACAO';
export const CHANGED_PROJECT_VALUE_ACTION = 'CHANGED_PROJECT_VALUE_ACTION';
export const CHANGED_PROJECT_ID_ACTION = 'CHANGED_PROJECT_ID_ACTION';
export const LOADED_PROJETOS_PAGE_ACTION = 'LOADED_PROJETOS_PAGE_ACTION';
export const CLEARED_PROJETOS_PAGE_ACTION = 'CLEARED_PROJETOS_PAGE_ACTION';
export const LOADED_PROJECT_ACTION = 'LOADED_PROJECT_ACTION';
export const LOADED_HISTORICO_AVALIACOES_ACTION =
  'LOADED_HISTORICO_AVALIACOES_ACTION';
export const CLEARED_PROJECT_ACTION = 'CLEARED_PROJECT_ACTION';
export const PROJECT_ADDEDED_DOCUMENT_ACTION =
  'PROJECT_ADDEDED_DOCUMENT_ACTION';
export const PROJECT_EDITED_DOCUMENT_ACTION = 'PROJECT_EDITED_DOCUMENT_ACTION';
export const PROJECT_REMOVED_DOCUMENT_ACTION =
  'PROJECT_REMOVED_DOCUMENT_ACTION';
export const DOWNLOAD_PROJETO_PDF_ACTION = 'DOWNLOAD_PROJETO_PDF_ACTION';
export const DOWNLOADING_PROJETO_PDF_ACTION = 'DOWNLOADING_PROJETO_PDF_ACTION';

export const LOADING_REMOVE_PROJECT_ACTION = 'LOADING_REMOVE_PROJECT_ACTION';

export const CHANGED_CHECK_COORDENADOR_LOCAL =
  'CHANGED_CHECK_COORDENADOR_LOCAL';

export const getProjetoActionsS3ApiUrl = () => {
  return getApis().apis.bff + 'v1/documento';
};

export const resetProjetosReducer = () => ({
  type: RESETED_PROJETOS,
  payload: null,
});

const dispatchProjetoSuccess = (dispatch, projeto) => {
  if (projeto.avaliacao) {
    dispatch(changeAvaliacao(projeto.avaliacao));
  }
  if (projeto.id) {
    dispatch(changeProjetoValue('id', projeto.id));
  }
};

export const clearProjeto = () => ({
  type: CLEARED_PROJECT_ACTION,
  payload: null,
});

export const changeAvaliacao = (avaliacao) => ({
  type: CHANGED_PROJECT_CHANGED_AVALIACAO,
  payload: avaliacao,
});

export const changeProjetoValue = (name, value) => {
  if (typeof value === 'string') {
    if (value.trim().length > 0) {
      return {
        type: CHANGED_PROJECT_VALUE_ACTION,
        payload: { name, value },
      };
    } else {
      return {
        type: CHANGED_PROJECT_VALUE_ACTION,
        payload: { name, value: '' },
      };
    }
  }
  return {
    type: CHANGED_PROJECT_VALUE_ACTION,
    payload: { name, value },
  };
};

export const changeId = (id) => ({
  type: CHANGED_PROJECT_ID_ACTION,
  payload: id,
});

export const getDocumentFullPath = (id) => {
  return `${getProjetoActionsS3ApiUrl()}/${id}`;
};

const getDocumentsWithFullPath = (documents) => {
  let list = [];
  documents.map((file, index) => {
    list.push({
      ...file,
      id: file.caminho,
      caminho: file.caminho,
    });
    return index;
  });
  return list;
};

export const loadHistoricoAvaliacoes = (
  projetoId,
  etapa,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    toRequest(
      'get',
      [`${getEndpointBff(1, '/avaliacao/pufv')}?idProjeto=${projetoId}&etapa=${etapa}`],
      'projetoHistoricoEtapa'
    ).then(
      (resp) => {
        dispatch({
          type: LOADED_HISTORICO_AVALIACOES_ACTION,
          payload: {
            historico: resp.data.historico,
            etapa,
          },
        });
        if (resp.data && resp.data.length) {
          dispatch(
            changeAvaliacao({
              etapa,
              status: resp.data.status,
            })
          );
        }
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const avaliarProjeto = (
  projetoId,
  comentario,
  usuarioId,
  nomeAssessor,
  etapa,
  status,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    const data = {
      comentario,
      cpfAssessor: usuarioId,
      nomeAssessor,
      etapa,
      status,
    };
    toRequest(
      'put',
      [`${getEndpointBff(1, '/avaliacao/pufv')}?idProjeto=${projetoId}`, data],
      'save'
    ).then(
      () => {
        dispatch(
          changeAvaliacao({
            etapa,
            status,
          })
        );
        dispatch(loadHistoricoAvaliacoes(projetoId, etapa));
        loadHistoricoAvaliacoes(projetoId, etapa);
        callbackSuccess();
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadProjeto = (id, callbackSuccess, callbackError) => {
  return (dispatch) => {
    toRequest('get', [`${getEndpointBff()}/${id}`], 'projeto').then(
      (resp) => {
        let projeto = { ...resp.data };
        if (
          projeto.idPrincipiosValores[0] !== FIXED_PRINCIPOS_VALORES[0] ||
          projeto.idPrincipiosValores[1] !== FIXED_PRINCIPOS_VALORES[1]
        ) {
          projeto.idPrincipiosValores = [
            ...projeto.idPrincipiosValores,
            ...FIXED_PRINCIPOS_VALORES,
          ];
        }
        projeto.documentos = getDocumentsWithFullPath(projeto.documentos);
        dispatch({
          type: LOADED_PROJECT_ACTION,
          payload: projeto,
        });
        callbackSuccess();
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const saveProjeto = (projeto, callbackSuccess, callbackError) => {
  return (dispatch) => {
    let newState = { ...projeto };
    if (newState.avaliacao) {
      newState.avaliacoes = [newState.avaliacao];
      delete newState.avaliacao;
    }
    if (newState.id) {
      delete newState.id;
    }
    toRequest(
      'put',
      [`${getEndpointBff()}/${projeto.id}`, newState],
      'save'
    ).then(
      () => {
        dispatchProjetoSuccess(dispatch, {
          avaliacao: projeto.avaliacao,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess();
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

const getAvaliacaoDraft = (etapaIndex) => {
  return {
    etapa: etapaIndex,
    status: PROJECT_STATUS_RASCUNHO,
  };
};

export const editarDocumento = (file) => ({
  type: PROJECT_EDITED_DOCUMENT_ACTION,
  payload: file,
});

export const removerDocumentoLocal = (file) => ({
  type: PROJECT_EDITED_DOCUMENT_ACTION,
  payload: file,
});

export const uploadDocumento = (
  file,
  callbackSuccess,
  callbackError,
  callbackProgress
) => {
  return (dispatch) => {
    let data = new FormData();
    data.append('etapa', file.etapa);
    data.append('projeto', file.idProjeto);
    data.append('coop', file.cooperativa);
    data.append('file', file.file);
    toRequest(
      'post',
      [
        `${getProjetoActionsS3ApiUrl()}`,
        data,
        {
          headers: {
            'content-type':
              'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
          },
          onUploadProgress: ({ total, loaded }) => {
            const percent = Number(
              Math.round((loaded / total) * 100).toFixed(2)
            );
            callbackProgress({ percent }, file);
          },
        },
      ],
      'save'
    ).then(
      (resp) => {
        let newFile = {
          ...file,
          id: resp.data,
        };
        delete newFile.status;
        dispatch(removerDocumentoLocal(newFile));
        callbackSuccess(resp, file);
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const removerDocumento = (id, callbackSuccess, callbackError) => {
  return (dispatch) => {
    toRequest(
      'delete',
      [`${getProjetoActionsS3ApiUrl()}/${id}`],
      'save'
    ).then(
      (resp) => {
        dispatch({
          type: PROJECT_REMOVED_DOCUMENT_ACTION,
          payload: id,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const registerPreEtapa = (preEtapa, callbackSuccess, callbackError) => {
  return (dispatch) => {
    let newState = { ...preEtapa };
    if (newState.avaliacao) {
      newState.avaliacoes = [
        newState.avaliacao,
        getAvaliacaoDraft(1),
        getAvaliacaoDraft(2),
        getAvaliacaoDraft(3),
        getAvaliacaoDraft(4),
        getAvaliacaoDraft(5),
        getAvaliacaoDraft(6),
        getAvaliacaoDraft(7),
        getAvaliacaoDraft(8),
        getAvaliacaoDraft(9),
        getAvaliacaoDraft(10),
      ];
      delete newState.avaliacao;
    }
    toRequest('put', [`${getEndpointBff()}/`, newState], 'save').then(
      (resp) => {
        dispatchProjetoSuccess(dispatch, {
          avaliacao: preEtapa.avaliacao,
          id: resp.data.id,
        });
        callbackSuccess();
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const clearProjetosPageList = () => ({
  type: CLEARED_PROJETOS_PAGE_ACTION,
  payload: null,
});

export const removerProjeto = (id, callbackSuccess, callbackError) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_REMOVE_PROJECT_ACTION,
      payload: true,
    });
    toRequest('delete', [`${getEndpointBff()}/${id}`], 'save').then(
      (resp) => {
        dispatch({
          type: LOADING_REMOVE_PROJECT_ACTION,
          payload: false,
        });
        // dispatchProjetoSuccess(dispatch, {
        //   checkCoordenador: resp.checkCoordenador
        // });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        dispatch({
          type: LOADING_REMOVE_PROJECT_ACTION,
          payload: false,
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const alterarCheckCoordenador = (
  projetoId,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    toRequest(
      'put',
      [`${getEndpointBff()}/${projetoId}/visualizar/coordenador`],
      'save'
    ).then(
      (resp) => {
        dispatch({
          type: CHANGED_CHECK_COORDENADOR_LOCAL,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const alterarCheckProfGestor = (
  projetoId,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    toRequest(
      'put',
      [`${getEndpointBff()}/${projetoId}/visualizar/prof-gestor`],
      'save'
    ).then(
      (resp) => {
        dispatch({
          type: CHANGED_CHECK_COORDENADOR_LOCAL,
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp);
        }
      },
      (error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const generateProjetoPdf = (
  projetoId,
  callbackProgress,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    dispatch({
      type: DOWNLOADING_PROJETO_PDF_ACTION,
      payload: {
        loading: true,
        id: projetoId,
      },
    });
    toRequest('get', [
      `${getEndpointBff()}/pdf/${projetoId}`,
      {
        onDownloadProgress: (event) => {
          if (typeof callbackProgress === 'function') {
            callbackProgress(event);
          }
        },
        responseType: 'arraybuffer',
        headers: {
          Accept: 'text/csv',
          'Access-Control-Allow-Headers':
            'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
        },
      },
    ]).then(
      (resp) => {
        dispatch({
          type: DOWNLOADING_PROJETO_PDF_ACTION,
          payload: {
            loading: false,
            id: projetoId,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(resp.data);
        }
      },
      (error) => {
        dispatch({
          type: DOWNLOADING_PROJETO_PDF_ACTION,
          payload: {
            loading: false,
            id: projetoId,
          },
        });
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      }
    );
  };
};

export const loadProjetosPaginados = (
  filters,
  page,
  size,
  callbackSuccess,
  callbackError
) => {
  return (dispatch) => {
    const text = filters.busca;
    size = size || 10;

    const dataInicio = convertDateToIso(filters.dataInicio);
    const dataFim = convertDateToIso(filters.dataFim);
    const filtrarPor = filters.filtrarPor;
    const filtro = filters.filtro;
    const ativo = filters.ativo;
    const cleanArray = (arr) => arr.filter((item) => item !== '');
    const cleanedFilters = {
      filtro,
      filtrarPor,
      status: filters.status,
      etapasEnsino: cleanArray(filters.etapasEnsino),
      coop: cleanArray(filters.coop),
      idEstado: cleanArray(filters.idEstado),
      nomCidade: cleanArray(filters.nomCidade),
      dataInicio,
      dataFim,
      ativo,
    };

    api
      .post(
        `${getEndpointBff()}/page?page=${page}&size=${size}`,
        cleanedFilters,
        // config
      )
      .then((response) => {
        dispatch({
          type: LOADED_PROJETOS_PAGE_ACTION,
          payload: {
            ...response.data,
            busca: text,
            filtrarPor,
            filtro,
            status: cleanedFilters.status,
            etapasEnsino: cleanedFilters.etapasEnsino,
            coop: cleanedFilters.coop,
            idEstado: cleanedFilters.idEstado,
            nomCidade: cleanedFilters.nomCidade,
            dataInicio,
            dataFim,
            page: page,
          },
        });
        if (typeof callbackSuccess === 'function') {
          callbackSuccess(response.data);
        }
      })
      .catch((error) => {
        if (typeof callbackError === 'function') {
          callbackError(error);
        }
      });
  };
};

export const ativarProjeto = (projetoId, callbackSuccess, callbackError) => {
  api
    .put(`${getEndpointBff()}/${projetoId}/ativar`)
    .then((response) => {
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(response.data);
      }
    })
    .catch((error) => {
      if (typeof callbackError === 'function') {
        callbackError(error);
      }
    });
};

export const desativarProjeto = (projetoId, callbackSuccess, callbackError) => {
  api
    .put(`${getEndpointBff()}/${projetoId}/desativar`)
    .then((response) => {
      if (typeof callbackSuccess === 'function') {
        callbackSuccess(response.data);
      }
    })
    .catch((error) => {
      if (typeof callbackError === 'function') {
        callbackError(error);
      }
    });
};
